export enum RedoMarketplaceVariantFieldType {
  Sku = "sku",
  Price = "price",
  Title = "title",
  CompareAtPrice = "compare_at_price",
}
